import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'
  const {
    palette: {
      blue_300: { main: blue300 } = {},
      gray_400: { main: gray400 } = {},
      dark_50: { main: dark50 } = {}
    } = {}
  } = theme
  return {
    containerPagination: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0px 4px',
      height: '45px',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
        flexWrap: 'wrap',
        padding: '8px 4px'
      }
    },
    contentPagination: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      rowGap: 8,
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        width: '100%'
      }
    },
    numberPerPage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end'
    },
    countPerPage: {
      marginLeft: 16,
      color: isDark ? dark50 : gray400,
      whiteSpace: 'nowrap'
    },
    exibitionPagination: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      rowGap: 8,
      padding: '0px 8px !important'
    },
    perPageSelect: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      '& span': {
        color: isDark ? dark50 : gray400
      }
    },
    selectWrapper: {
      minWidth: 72,
      flexShrink: 0
    },
    buttonNext: {
      backgroundColor: 'transparent',
      color: isDark ? dark50 : gray400,
      padding: '0px !important',
      '&:hover': {
        backgroundColor: 'transparent',
        color: blue300
      }
    },
    pageNumberOfRowsPage: {
      color: isDark ? dark50 : gray400,
      margin: '0 16px'
    }
  }
})
